var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44 16H16C13.8783 16 11.8434 16.8429 10.3431 18.3431C8.84285 19.8434 8 21.8783 8 24V80C8 82.1217 8.84285 84.1566 10.3431 85.6569C11.8434 87.1571 13.8783 88 16 88H72C74.1217 88 76.1566 87.1571 77.6569 85.6569C79.1571 84.1566 80 82.1217 80 80V52","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M74 9.99993C75.5913 8.40863 77.7496 7.51465 80 7.51465C82.2504 7.51465 84.4087 8.40863 86 9.99993C87.5913 11.5912 88.4853 13.7495 88.4853 15.9999C88.4853 18.2504 87.5913 20.4086 86 21.9999L48 59.9999L32 63.9999L36 47.9999L74 9.99993Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Edit.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
